import { useEffect } from 'react'
import Policy from '../../components/Desktop/Policy'

const Disclaimer = () => {

  useEffect(() => {
    document.title = `HomeCook | Disclaimer`
  }, [])

  return (
      <div className='flex flex-col h-[900px] overflow-y-auto sm:h-screen justify-start'>
      <p className='text-md mx-auto mt-20 text-primaryDark-200 font-raleway font-semibold'>Disclaimer</p>
      <div className='w-11/12 mx-auto font-open-sans font-medium'>
        <Policy policyKey={process.env.REACT_APP_DISCLAIMER_KEY} />
      </div>
    </div>
  )
}

export default Disclaimer